import { SVGIconProps } from '../types/svg';

export const Incendie = ({ ...props }: SVGIconProps) => (
    <svg width="65" height="65" viewBox="0 0 65 65" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M27.482 53.9121C7.70899 44.5832 21.1662 28.3598 26.8216 23.4475C33.5916 17.5446 30.7019 12.6323 30.7019 12.6323C51.2595 23.9016 41.6412 42.9728 41.6412 42.9728C46.5535 39.6702 46.0169 33.2718 46.0169 33.2718C53.4062 49.949 36.9354 53.9122 36.9354 53.9122"
            stroke="#00354F"
            strokeWidth="1.44"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M27.1284 35.3701C27.1284 35.3701 21.1892 44.9243 31.841 52.9937C38.1681 46.4092 36.4898 43.0523 36.4898 43.0523" stroke="#278BE5" strokeWidth="1.44" strokeLinecap="round" />
        <path d="M21.6696 21.5297C25.1668 19.3193 26.918 16.0801 26.4316 13.98" stroke="#FF8A02" strokeWidth="1.44" strokeLinecap="round" />
        <path d="M40.5029 13.6401C42.0508 14.7937 45.3332 18.0544 46.08 21.8681" stroke="#FF8A02" strokeWidth="1.44" strokeLinecap="round" />
    </svg>
);
